import React, { Component } from "react";
import Imgloading from "./itemloading";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

class Two extends Component {
  data = this.props.Data;
  language = this.props.Language;

  priceText(text) {
    if (text == "small")
      return (
        <span>
          {this.props.Language == "en"
            ? "small"
            : this.props.Language == "krd"
            ? "بچیک"
            : "صغیر"}
        </span>
      );
    else if (text == "medium")
      return (
        <span>
          {this.props.Language == "en"
            ? "medium"
            : this.props.Language == "krd"
            ? "ناڤنجی"
            : "متوسط"}
        </span>
      );
    else
      return (
        <span>
          {this.props.Language == "en"
            ? "large"
            : this.props.Language == "krd"
            ? "مەزن"
            : "کبير"}
        </span>
      );
  }

  addItemToCart = () => {
    this.props.addCartItem(this.data);
  };

  render() {
    return (
      <div className="item two-cart ani-fade-in">
        <div className="two-cart-image-container">
          <PhotoView
            key={this.data.id}
            src={this.data.image}
            overlay={this.data}
          >
            <div className="image">
              <Imgloading Img={this.data.image} />
            </div>
          </PhotoView>

          <div className="addToCart">
            <button
              className="addToCartButton"
              onClick={() => this.addItemToCart()}
            >
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="19" height="19" fill="white" fill-opacity="0.82" />
                <rect
                  x="9"
                  y="2"
                  width="1"
                  height="15"
                  rx="0.5"
                  fill="#123424"
                />
                <rect
                  x="17"
                  y="9"
                  width="1"
                  height="15"
                  rx="0.5"
                  transform="rotate(90 17 9)"
                  fill="#123424"
                />
              </svg>
            </button>
            {/* <div className='action'>
                        <i className="fa-solid fa-plus"></i>
                        0
                        <i className="fa-solid fa-minus"></i>
                    </div> */}
          </div>
        </div>

        {/* <span className="item-order">{this.data.order??0}</span> */}
        <div className="info-container">
          <h5
            style={this.props.Language == "en" ? { letterSpacing: "1px" } : {}}
          >
            {this.props.Language == "en"
              ? this.data.name_eng
              : this.props.Language == "krd"
              ? this.data.name_krd
              : this.data.name_ar}
          </h5>
          <div className="price">
            {this.data.price_small && this.data.price_max ? (
              <>
                <span>
                  {this.priceText("small")}
                  {this.data.price_small}
                </span>
                <span>
                  {this.priceText("medium")}
                  {this.data.price}
                </span>
                <span>
                  {this.priceText("big")}
                  {this.data.price_max}
                </span>
              </>
            ) : this.data.price_small ? (
              <>
                <span>
                  {this.priceText("small")}
                  {this.data.price_small}
                </span>

                <span>
                  {this.priceText("medium")}
                  {this.data.price}
                </span>
              </>
            ) : this.data.price_max ? (
              <>
                <span>
                  {this.priceText("medium")}
                  {this.data.price}
                </span>
                <span>
                  {this.priceText("big")}
                  {this.data.price_max}
                </span>
              </>
            ) : (
              <span> {this.data.price} </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Two;
